export default __webpack_public_path__ + "static/media/nftInfoCard.4999b1ae.png";